import contact from '@/api/front/contact-us'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return contact.get({ params: {
        ...attrubutes
    }})
  }
}
